import React from 'react';
import {
    Box,
    Typography,
    Divider,
    Grid,
    Stack,
    Paper,
    Button
} from '@mui/material';
import {
    KingBed,
    Bathtub,
    Balcony,
    Power,
    PriceChange,
    Layers,
    LocationOn,
    Opacity,
    SquareFoot,
    CalendarToday
} from '@mui/icons-material';
import { useSelector } from 'react-redux';
 
const YourIndividualVillaDetails = ({ propertyData }) => {
 
    const theme = useSelector((data) => data.themeValue.colors);
    if (!propertyData?.length) {
        return <Typography sx={{ p: 2 }}>No property details available.</Typography>;
    }
 
    const rawData = propertyData[0]?.ExtraData || {};
    let villa = propertyData[0];
 
    const villaData = [
        { icon: <KingBed fontSize="small" sx={{ color: theme.normal_icon }} />, label: "Bedrooms", value: rawData?.Bedrooms || "NA" },
        { icon: <Bathtub fontSize="small" sx={{ color: theme.normal_icon }} />, label: "Bathrooms", value: rawData?.Bathrooms || "NA" },
        { icon: <Layers fontSize="small" sx={{ color: theme.normal_icon }} />, label: "Floors", value: rawData?.NoOfFloors || "NA" },
        { icon: <Balcony fontSize="small" sx={{ color: theme.normal_icon }} />, label: "Balcony", value: rawData?.Balcony === 0 ? "No" : rawData?.Balcony },
        { icon: <Power fontSize="small" sx={{ color: theme.normal_icon }} />, label: "Power Backup", value: rawData?.PowerBackUp || "NA" },
        { icon: <Opacity fontSize="small" sx={{ color: theme.normal_icon }} />, label: "Water Supply", value: rawData?.WaterSupply || "NA" },
        { icon: <SquareFoot fontSize='small' sx={{ color: theme.normal_icon }} />, label: "Size In SqFt", value: villa?.SizeInSqFt || "NA" },
        { icon: <CalendarToday color="primary" sx={{ color: theme.normal_icon }} />, label: "Age of Building", value: rawData.AgeOfBuilding || "NA" },
        // { icon: <PriceChange fontSize='small' />, label: "SqFt Price", value: villa?.SqFtPrice || "NA" }
    ];
 
    return (
        <Paper
            elevation={0}
            sx={{
                p: 3,
                height: '100%',
                overflow: 'hidden',
                display: 'flex',
                flexDirection: 'column',
                gap: 2,
                border: '1px solid',
                borderColor: theme.borderColor,
                borderRadius: 2,
                maxWidth: 600,
                margin: '0 auto',
                backgroundColor: theme.background
            }}
        >
            <Box>
                <Typography
                    variant="h6"
                    sx={{
                        fontWeight: 600,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1.5,
                        mb: 0.5,
                        color: theme.text
                    }}
                >
                    {villa?.PropertyName}
                </Typography>
                <Box display="flex" alignItems="center" gap={1}>
                    <LocationOn fontSize="small" sx={{ color: theme.normal_icon }} />
                    <Typography variant="body2" sx={{ color: theme.text }}>
                        {villa?.Address}, {villa?.City}
                    </Typography>
                </Box>
                <Divider sx={{ my: 2, backgroundColor: theme.secondary_text_color }} />
            </Box>
 
            <Grid
                container
                spacing={{ xs: 1.5, sm: 2 }}
                sx={{
                    flex: 1,
                    overflowY: 'auto',
                    justifyContent: "center",
                    pr: 1,
                    '&::-webkit-scrollbar': {
                        width: '6px',
                    },
                    '&::-webkit-scrollbar-thumb': {
                        backgroundColor: theme.borderColor,
                        borderRadius: 3,
                    },
                    backgroundColor: theme.background
                }}
            >
                {villaData.map((item, index) => (
                    <Grid xs={12} sm={6} md={4} key={index} >
                        <Box
                            sx={{
                                width: {
                                    xs: "8.5rem",  // extra-small (mobile)
                                    sm: "10rem",  // small (tablet portrait)
                                    md: "10rem",  // medium (tablet landscape)
                                    lg: "10rem",  // large (laptop)
                                    xl: "10rem",  // extra-large (desktop)
                                },
                                height: { xs: "7rem", sm: "5rem" },
                                display: "flex",
                                alignItems: "center",
                                gap: 1.5,
                                p: 0.5,
                                border: "1px solid",
                                borderColor: theme.borderColor,
                                borderRadius: 1,
 
                            }}
                        >
                            {item.icon}
                            <Box >
                                <Typography variant="caption" sx={{ color: theme.text }} fontWeight={600}>
                                    {item.value}
                                </Typography>
                                <Typography variant="body2" sx={{ color: theme.text }}>
                                    {item.label}
                                </Typography>
                            </Box>
                        </Box>
                    </Grid>
                ))}
            </Grid>
        </Paper>
    );
};
 
export default YourIndividualVillaDetails;